export default class Header {
  constructor(element) {
    this.element = element;
    this.options = {
      threshold: 0.1,
      alwaysShow: false,
    };
    this.scrollPosition = document.scrollingElement.scrollTop;
    this.lastScrollPositon = document.scrollingElement.scrollTop;
    this.html = document.documentElement;

    this.init();
    this.initNavMobile();
  }

  init() {
    this.setOptions();

    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  setOptions() {
    if ('threshold' in this.element.dataset) {
      this.options.threshold = this.element.dataset.threshold;
    }
    this.options.alwaysShow = this.element.dataset.alwaysShow;
  }

  initNavMobile() {
    const toggle = this.element.querySelector('.js-toggle');
    toggle.addEventListener('click', this.onToggleNav.bind(this));
  }

  onToggleNav() {
    console.log('Allo');
    this.html.classList.toggle('nav-is-active');
  }

  onScroll() {
    this.lastScrollPosition = this.scrollPosition;
    this.scrollPosition = document.scrollingElement.scrollTop;

    this.setHeaderState();
    this.setDirections();
  }

  setDirections() {
    if (this.scrollPosition >= this.lastScrollPosition) {
      this.html.classList.add('is-scrolling-down');
      this.html.classList.remove('is-scrolling-up');
    } else {
      this.html.classList.remove('is-scrolling-down');
      this.html.classList.add('is-scrolling-up');
    }
  }

  setHeaderState() {
    if (
      document.scrollingElement.scrollHeight * this.options.threshold <
        this.scrollPosition &&
      this.options.alwaysShow == undefined
    ) {
      this.html.classList.add('header-is-hidden');
    }
    if (this.scrollPosition <= this.lastScrollPosition) {
      this.html.classList.remove('header-is-hidden');
    }
  }
}
